module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.show,
      "width": _vm.width,
      "top": "0",
      "show-close": _vm.showClose,
      "custom-class": _vm.wTheme,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.show = $event
      },
      "close": _vm.close1
    }
  }, [_c('p', {
    staticClass: "modal-header",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.closeFooter) ? _c('div', {
    staticClass: "modal-bottom",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.hasOnOK) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v(_vm._s(_vm.okText))]) : _vm._e(), _vm._v(" "), (_vm.hasOnCancel) ? _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-5be0649a!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/src/index.vue
// module id = 308
// module chunks = 99 100